import { mapState as rootMapState } from 'pinia';
import { mapState, mapActions } from '@/store/helpers';
import { useUserStore, usePageStore } from '@/store';

import Select from '../select.vue';
import Loading from '../loading.vue';
import EmptyListing from './_components/empty-listing/index.vue';
import util from '../../common/util';
import { formats } from '../../common/format';

import * as TYPES from './_store/types';
import propsToData from '@/mixins/props-to-data';
import {
    localStorageSortKey,
    localStorageViewPatternKey
} from '@/modules/md-search/_conf';
import dispatchCondition from './_mixins/dispatch-condition';
import { mapAsyncData } from '../../plugins/asyncData';
import MlsDisclaimer from '@/modules/md-footer/mls-disclaimer.vue';
import { subModulesMixin } from './subModules';
import { onLocationTypeChanged } from './asyncData';

import { normalizeParams } from './_center-adaptor/normalizeParams';

import { searchRealTimeListings } from '@/common/search-request';

import { defineAsyncComponent } from 'vue';
import { buildUrl } from '@/router/index.js';


const KEY_TYPE_MAP = 'map';
const KEY_TYPE_GRID = 'grid';
const KEY_TYPE_LIST = 'list';

export default {
    i18next: {
        ns: 'md-search-result'
    },
    mixins: [dispatchCondition(), propsToData, subModulesMixin],
    // i18next: {
    //     //  renew $t, trigger computed recalculate listingSortOptions
    //     ns: 'common'
    // },
    components: {
        Select,
        Loading,
        MlsDisclaimer,
        EmptyListing,
        EmptyStatusCenter: defineAsyncComponent(() =>
            import(
                /* webpackChunkName: "components/searchResult/emptyCenter"*/ './_components/emptyStatus-center.vue'
            )),
        EmptyStatus: defineAsyncComponent(() =>
            import(
                /* webpackChunkName: "components/searchResult/empty"*/ './_components/emptyStatus.vue'
            ))
    },
    props: [
        'hideBelow',
        'top',
        // 'originMode',
        'showSchool',
        'mapSearchText',
        'mapDrawTip',
        'hideSearchChoose'
    ],
    data: function() {
        const blockData = {
            scrollwheel: false,
            hideRedo: false, //  whether to hide  redo search on map
            hidePlot: false //  whether to hide  plot icon
        };
        return {
            height: '',
            mapCenter: null,
            drawingZoom: 0,
            boundary: null,
            geometry: null,
            // hasMap: false,
            hideQuickSearch: false,
            ...blockData,
            // Add empty listing form configuration
            allowShowEmptyListingForm: false,
            formTemplate: {},
            searchMapRef: null,
            inBeforeMount: false,
            isDisabledEmptyZoomOut: false,
            mapShown: false
        };
    },
    provide() {
        return {
            hideRedo: this.hideRedo, //  whether to hide  redo search on map
            hidePlot: this.hidePlot //  whether to hide  plot icon
        };
    },
    inject: {
        showSearchBar: {
            type: Boolean,
            default: true
        },
        resetParentHeight: {
            from: 'resetHeight',
            default() {
                return () => {}
            }
        },
        id: {
            from: 'id'
        },
        onlyShowHouses: {
            from: 'onlyShowHouses',
            default: false
        }
    },
    watch: {
        layout: {
            handler: function(newVal, oldVal) {
                if ((newVal === 'map' && oldVal !== 'mixed') || (newVal === 'mixed' && oldVal !== 'map')) {
                    let mapPath =
                        (this.mapCondition && this.mapCondition.mapPath) || '';
                    let mapRadius =
                        this.mapCondition && this.mapCondition.mapRadius;
                    let mapSearch =
                        this.mapCondition && this.mapCondition.mapSearch;
                    try {
                        if (this.mapCenter && (mapRadius || mapPath || mapSearch)) {
                            const mapDom = this.$refs.searchMap?.$refs.map;
                            if (mapRadius) {
                                let mapCenter;
                                if (this.isSearchCenter) {
                                    mapCenter = JSON.parse(
                                        mapRadius[0]
                                    ).originPoint;
                                } else {
                                    mapCenter =
                                        JSON.parse(mapRadius)[0].originPoint;
                                }
                                setTimeout(() => {
                                    mapCenter && mapDom?.setCenter(mapCenter); //center to mapRadius
                                });
                            }
                            if (mapPath) {
                                mapPath = JSON.parse(mapPath);
                                setTimeout(() => {
                                    mapDom?.setZoom(mapPath); //center to mapPath
                                });
                            }
                        } else {
                            this.getCenterPoint();
                        }
                    } catch (error) {
                        this.getCenterPoint();
                    }
                }
                if (this.searchMapRef) {
                    this.searchMapRef.resize();
                }
            }
        },
        mapData: {
            deep: true,
            immediate: true,
            handler: function(val, oldVal) {
                if (!util.isSSRServer) {
                    let oldCenter = oldVal && oldVal.centerPoint;
                    let newCenter = val && val.centerPoint;
                    let oldZoom = oldVal && oldVal.zoom;
                    let newZoom = val && val.zoom;
                    if (
                        val &&
                        oldVal &&
                        oldCenter === newCenter &&
                        oldZoom === newZoom
                    ) {
                        return;
                    }
                    if (this.keywords.length === 0 && newZoom) {
                        this.drawingZoom = newZoom;
                    }
                    if (newCenter) {
                        let points = newCenter.split(',');
                        this.mapCenter = {
                            lat: +points[0],
                            lng: +points[1]
                        };
                        !this.boundary && this.getDefaultCenterPoint(false);
                    } else {
                        this.getCenterPoint();
                    }
                }
            }
        },
        'mapCondition.zoom': {
            deep: true,
            immediate: true,
            handler: function(val) {
                if (this.isShowEmpty) {
                    this.zoom = val
                    this.mapData.zoom = val
                    this.drawingZoom = val
                    this.isDisabledEmptyZoomOut = val <= 4
                }
            }
        },
        top() {
            if (this.hideBelow) {
                this.resetHeight();
            }
        },
        page() {
            // if (this.hideBelow) {
            if (this.layout === 'normal') {
                this.$el.scrollIntoView();
            } else if (this.layout === 'mixed') {
                this.$refs.result.scrollTop = 0;
            }
        },
        locationType() {
            this.onLocationTypeChanged();
        },
        fetchedSearchData() {
            if (this.fetchedSearchData) {
                if (typeof this.resetParentHeight === 'function') {
                    this.resetParentHeight();
                }
                if (this.hideBelow) {
                    setTimeout(() => {
                        this.resetHeight();
                        window.addEventListener('resize', () =>
                            this.resetHeight());
                    }, 0);
                }
            }
        },
        loading(newVal, oldVal) {
            if (oldVal === true && newVal === false) {
                this.$refs.result && (this.$refs.result.scrollTop = 0);
            }
        },
        showMap(newVal) {
            if (newVal) {
                this.mapShown = newVal;
            }
        }
    },
    computed: {
        ...rootMapState(usePageStore, {
            "isSearchCenter": store => store.isSearchCenter,
            "global": store => store.page || {},
            "forCMS": "forCMS",
            "siteId": "siteId",
            currencySymbol: store => store.currency.symbol,
            currencyRate: store => store.currencyRate,
            currencyAbbr: store => store.currency.abbr, //  Short for current currency
            baseCurrency: store => store.baseCurrency //  base currency , USD
        }),
        isCurCurrencyEqualBaseCurrency() {
            //  Determine whether the currently selected currency is equal to the base currency
            return this.currencyAbbr === this.baseCurrency;
        },
        ...rootMapState(useUserStore, {
            "user": store => store.user
        }),
        ...mapState({
            "page": store => store.page,
            "pageSize": store => store.pageSize,
            "mode": store => store.mode,
            "layoutOptions": store => store.layoutOptions,
            "layout": store => store.layout,
            "sort": store => store.sort,
            "keywords": store => store.keywords,
            "mapCondition": store => store.mapCondition,
            "loading": store => store.loading,
            "isMapLoading": store => store.isMapLoading,
            "listingSource": store => store.listingSource,
            "drawing": store => store.drawing,
            "result": store => store.result,
            "gridOrListType": store => store.gridOrListType,
            "showInsight": store => store.showInsight,
            "fetchedSearchData": store => store.fetchedSearchData,
            "centerPoint": store => store.centerPoint,
            "zoom": store => store.zoom,
            "sortConfigs": store => store.listingSortOptions,
            "property_gathering_amount": store => store.property_gathering_amount,
            "mapResult": store => store.mapResult,
            "searchConfigMap": store => store.searchConfigMap,
            "breadCrumbs": store => store.breadCrumbs,
            "averageData": store => store.averageData,
            "searchParams": "searchParamsGetter",
            "isGridOrList": "isGridOrList",
            "isMixed": "isMixed",
            "listingType": "listingType",
            "locationType": "locationType",
            "searchParamsWithMap": "searchParamsWithMap",
            "locationCondition": "locationCondition",
            "resultListingType": "resultListingType",
            "otherSearchParams": "otherSearchParams",
            "allConditions": "allConditions",
            "outsideFields": "outsideFields",
            "conditionSort": "conditionSort",
            "conditions": "conditions"
        }),
        hasMap({ layoutOptions }) {
            return !(layoutOptions.length === 1 && layoutOptions[0] === 'normal');
        },
        isMobileSize() {
            return this.platform.isMobile;
        },
        wordPressSSR({ global }) {
            return global.wordPressSSR;
        },
        isFeatureAreaPage({ global }) {
            return global.pageKey === 'featured-area-search'
        },
        mapData() {
            let data = {
                property_gathering_amount: this.property_gathering_amount
            };
            if (this.centerPoint) {
                data.centerPoint = this.centerPoint;
            }
            data.zoom = this.zoom;
            return data;
        },
        showMap() {
            return this.layout === 'map' || this.layout === 'mixed';
            // return (
            //     this.layout === KEY_TYPE_MAP &&
            //     this.searchModuleType !== 'grid-list'
            // );
        },
        showOrShownMap() {
            return this.showMap || this.mapShown;
        },
        showSkeletonHouse() {
            return this.loading === true && this.showGrid
        },
        showSkeletonList() {
            return this.loading === true && this.showList
        },
        showList() {
            return (this.layout === 'normal' || this.layout === 'mixed') && this.gridOrListType === 'list';
        },
        showGrid() {
            return (this.layout === 'normal' || this.layout === 'mixed') && this.gridOrListType === 'grid';
        },
        count() {
            return this.result.counts || 0;
        },
        emptyCompName({ isSearchCenter }) {
            return isSearchCenter ? 'EmptyStatusCenter' : 'EmptyStatus'
        },
        isShowEmpty({ count }) {
            return count == 0
        },
        mlsCount({ global }) {
            let mlsOrgs = global.mlsOrgs || [],
                count = Number.MAX_VALUE;
            for (let i = 0, len = mlsOrgs.length; i < len; i++) {
                let limit = mlsOrgs[i].listingPictureLimit;
                if (limit !== -1 && limit < count) {
                    count = limit;
                }
            }
            return count;
        },
        searchCount({ global }) {
            if (this.count > this.mlsCount) {
                return formats.number(this.mlsCount, 0) + '+';
            } else if (global.listingCondition) {
                return '';
            } else {
                return formats.number(this.count, 0);
            }
        },
        isSold() {
            return (
                (this.result && this.result.searchType === 'sold') ||
                this.listingType === 'sold-listing'
            );
        },
        searchText({ global, keywords, count, $t }) {
            if (count == 0) {
                return $t('md-search-result.Property', {
                    count: Number(count)
                });
            }
            const flagTypes = [
                'open house listings',
                'price reduced listings',
                'new listings'
            ]; // Identify three lp
            if (
                flagTypes.includes(
                    this.listingSource?.split?.('$$')[0]
                )
            ) {
                return this.$t(
                    'md-search-result.' +
                        global.listingCondition?.listingConditionType
                );
            }
            if (global.pageKey === 'featured-area-search') {
                let area = keywords?.[0]?.keyword?.split?.(', ')?.[0] || ''
                return $t('featured-area-search.title', {
                    area,
                    count,
                    interpolation: { escapeValue: false }
                })
            }
            let prefix = '';
            let suffix = '';
            let address = '';
            const searchType = (this.result && this.result.searchType) || '';
            if (this.isSold) {
                prefix = 'sold';
            } else if (this.listingSource === 'rental listings') {
                return $t(`md-search-result.PropertyForRent`, {
                    count
                })
            } else if (!this.isMobileSize) {
                switch (searchType) {
                case 'For Rent': {
                    suffix = `ForRent`;
                    break;
                }
                case 'For Sale': {
                    suffix = `ForSale`;
                    break;
                }
                case 'neighborhood': {
                    suffix = `AvailableNearby`;
                    break;
                }
                default: {
                    suffix = `Available`;
                }
                }
                if (this.locationType === 'single' && this.breadCrumbs.length) {
                    const breadCrumbs = [...this.breadCrumbs].pop();
                    address = (breadCrumbs && breadCrumbs.name) || '';
                }
            }
            // }

            if (this.listingType === 'featured-listing') {
                prefix = 'featured';
            }

            return address
                ? $t(`md-search-result.${prefix}Property${suffix}In`, {
                    count,
                    address,
                    interpolation: { escapeValue: false }
                })
                : $t(`md-search-result.${prefix}Property${suffix}`, {
                    count
                });
        },
        containerCls({ theme, layout }) {
            if (this.showInsight) {
                return 'insight';
            } else if (layout === 'mixed') {
                if (['broker', 'layout1'].includes(theme)) {
                    return 'left';
                } else {
                    return 'right';
                }
            } else if (layout === 'map') {
                return 'big-map';
            }
            return '';
        },
        listingSortOptions() {
            let key = 'common:listingSortOptions';
            if (this.isSold) {
                key = 'common:soldlistingSortOptions';
            }
            let _defaultConfig = [
                {
                    label: this.$t(`${key}.RELEVANCE`),
                    value: 'RELEVANCE'
                }
            ];
            if (!this.sortConfigs || !util.isArray(this.sortConfigs)) {
                return _defaultConfig;
            }
            let _sortConfig = this.sortConfigs.filter(sort => {
                return sort.show !== false;
            });
            _sortConfig = _sortConfig.map(item => {
                return {
                    ...item,
                    label: this.$t(`${key}.${item.value}`)
                };
            });
            return _sortConfig.length === 0 ? _defaultConfig : _sortConfig;
        },
        modes() {
            let modes = [];
            if (this.isGridOrList) {
                if (this.showAllIcons) {
                    modes.push({
                        name: KEY_TYPE_LIST,
                        active: this.gridOrListType === KEY_TYPE_LIST
                    });
                    modes.push({
                        name: KEY_TYPE_GRID,
                        active: this.gridOrListType === KEY_TYPE_GRID
                    });
                } else {
                    modes.push({
                        name: this.gridOrListType === KEY_TYPE_GRID
                            ? KEY_TYPE_LIST
                            : KEY_TYPE_GRID
                    });
                }
            } else if (this.layout !== 'map') {
                modes.push({
                    name: KEY_TYPE_MAP,
                    active: this.layout === 'mixed'
                });
                if (this.showAllIcons) {
                    modes.push({
                        name: KEY_TYPE_LIST,
                        active: this.gridOrListType === KEY_TYPE_LIST,
                        sideActive: this.gridOrListType === KEY_TYPE_LIST
                    });
                    modes.push({
                        name: KEY_TYPE_GRID,
                        active: this.gridOrListType === KEY_TYPE_GRID,
                        sideActive: this.gridOrListType === KEY_TYPE_GRID
                    });
                } else {
                    if (this.gridOrListType === KEY_TYPE_GRID) {
                        modes.push({
                            name: KEY_TYPE_LIST
                        });
                    } else if (this.gridOrListType === KEY_TYPE_LIST) {
                        modes.push({
                            name: KEY_TYPE_GRID
                        });
                    }
                }
            }

            return modes;
        },
        showEmptyListingForm() {
            return (
                this.result?.listings?.length == 0 &&
                this.allowShowEmptyListingForm &&
                !this.loading
            );
        },
        conditionOfJson() {
            // Zhongtai Station searchParams that is condition
            return (
                this.searchParams.condition || JSON.stringify(this.searchParams)
            );
        },
        featureAreaSearchRefineLink({ keywords, isSearchCenter, global }) {
            let query = {};
            if (global.pageKey === 'featured-area-search') {
                let condition = {}, [keyword] = keywords;
                if (keyword) {
                    if (isSearchCenter) {
                        condition.location = {
                            [keyword.keywordType]: [keyword.keyword]
                        }
                        condition.listingstatus = ["Active"];
                        query['condition'] = JSON.stringify(condition);
                    } else {
                        query = {
                            key: keyword.keyword,
                            keywordType: keyword.keywordType,
                            'listingStatus-multi-Back-on-Market': 'Active'
                        }
                    }
                }
            }
            return buildUrl({ name: 'listing', query });
        },
        location() {
            return this.keywords[0] || {};
        },
        snapshotLink() {
            const { keyword: key, keywordType } = this.location;
            return util.setQueryField(
                normalizeParams(
                    this.isSearchCenter,
                    {
                        key,
                        keywordType
                    },
                    {},
                    { needKey: true }
                ),
                '/snapshot'
            );
        }
    },
    methods: {
        ...mapActions({
            "searchDataAction": TYPES.SEARCH_DATA_ACTION,
            "updateUrl": TYPES.UPDATE_URL,
            "mapChangeMutation": TYPES.MAP_CHANGE_MUTATION,
            "pageChangeMutation": TYPES.PAGE_CHANGE_MUTATION,
            "quickSearchStateMutation": TYPES.QUICK_SEARCH_STATE_MUTATION,
            "sortUpdateMutation": TYPES.SORT_UPDATE_MUTATION,
            "gridOrListTypeMutation": TYPES.GRID_OR_LIST_TYPE_MUTATION,
            "layoutUpdateMutation": TYPES.LAYOUT_UPDATE_MUTATION,
            "activeHouseMarkerMutation": TYPES.ACTIVE_HOUSE_MARKER_MUTATION,
            "removeAllFiltersMutation": TYPES.REMOVE_ALL_FILTERS,
            "removeOutlineRegionMutation": TYPES.REMOVE_OUTLINE_REGION,
            "setShowInsight": TYPES.SHOW_INSIGHT_UPDATE_MUTATION,
            "averageDataMutation": TYPES.AVERAGE_DATA_MUTATION,
        }),
        getAverageData() {
            let keyword = this.keywords[0];
            if (!keyword) {
                return;
            }
            const params = normalizeParams(
                this.isSearchCenter,
                {
                    key: keyword.keyword,
                    keywordType: keyword.keywordType,
                    'listingStatus-multi-Back-on-Market': 'Active',
                    'purchaseType-For-Sale-Rent': '1'
                },
                {},
                { needKey: true }
            );
            params.avgTypes = [
                'AVG_PRICE',
                'AVG_BEDROOMS',
                'AVG_BATHS',
                'AVG_SQFT'
            ];
            params.cache = false;
            params.timezone = this.getCookie('timezone') || util.getTimeZone();
            searchRealTimeListings.call(this, {
                params,
                type: 'neighborAvg',
                globalData: this.global
            }).then(ret => {
                const { avgExcludeInvalidResults, counts } = ret.data || ret;
                const { avgResultList } = avgExcludeInvalidResults || {};
                
                this.averageDataMutation({
                    counts: counts || 0,
                    avgResultList: avgResultList || []
                });
            });
        },
        onSearchMapRef(e) {
            this.searchMapRef = e;
        },
        onLocationTypeChanged: mapAsyncData(onLocationTypeChanged),
        getCenterPoint() {
            if (this.layout === 'map' || this.layout === 'mixed') {
                if (this.keywords.length === 0) {
                    this.geometry = [];
                }
                if (
                    this.keywords.length === 0 &&
                    this.mapData &&
                    this.mapData.centerPoint
                ) {
                    let points = this.mapData.centerPoint.split(',');
                    this.boundary = null;
                    this.mapCenter = {
                        lat: +points[0],
                        lng: +points[1]
                    };
                    if (this.mapData.zoom) {
                        this.drawingZoom = this.mapData.zoom;
                    }
                    this.getDefaultCenterPoint(false);
                } else if (this.keywords.length > 0) {
                    let data = {};
                    this.keywords.forEach(({ keyword, keywordType }) => {
                        if (keywordType === 'streetAddress') {
                            keyword = keyword.split(',')[0];
                        }
                        if (data[keywordType]) {
                            data[keywordType] =
                                data[keywordType] + ';' + keyword;
                        } else {
                            data[keywordType] = keyword;
                        }
                    });
                    let mlsOrgs = this.global.mlsOrgs || [];
                    data.mlsOrgIds = [];
                    mlsOrgs.forEach(
                        value =>
                            value && value.id && data.mlsOrgIds.push(value.id)
                    );
                    // fix:keywordType for none The problem that the map does not locate the listing
                    const isNoneKeywordType = this.keywords.every(
                        keyword => keyword.keywordType === 'none'
                    );
                    if (isNoneKeywordType) {
                        let unWatch = this.$watch(
                            'mapResult',
                            () => {
                                this.getNoneKeywordTypeCenterPoint();
                                unWatch();
                            },
                            { deep: true }
                        );
                    }
                    let ps = (this.centerPointPs = this.axiosIns
                        .post(
                            '/api-data/search-api/v1/listing/locationSearch',
                            data
                        )
                        .then(({ data }) => {
                            if (this.centerPointPs === ps) {
                                if (data && data.length === 2) {
                                    let lng1 = data[0].longitude;
                                    let lng2 = data[1].longitude;
                                    let lat1 = data[0].latitude;
                                    let lat2 = data[1].latitude;
                                    this.mapCenter = {
                                        lat: (lat1 + lat2) / 2,
                                        lng: (lng1 + lng2) / 2
                                    };
                                    this.boundary = {
                                        lngMin: Math.min(lng1, lng2),
                                        lngMax: Math.max(lng1, lng2),
                                        latMin: Math.min(lat1, lat2),
                                        latMax: Math.max(lat1, lat2)
                                    };
                                } else if (data && data.length === 1) {
                                    this.boundary = null;
                                    this.drawingZoom = 18;
                                    this.mapCenter = {
                                        lat: data[0].latitude,
                                        lng: data[0].longitude
                                    };
                                } else if (isNoneKeywordType) {
                                    //  not instantiated searchMap instantiated first
                                    !this.$refs.searchMap &&
                                        (this.mapCenter = { lat: 0, lng: 0 });
                                } else if (!this.boundary) {
                                    this.getDefaultCenterPoint();
                                }
                            }
                        }));
                    this.getBoundaries(data);
                } else {
                    this.getDefaultCenterPoint();
                }
            }
        },
        async getDefaultCenterPoint(flag = true) {
            const listingTypeMap = {
                'sold listings': 'sold-listing',
                'all listings': 'all-listing',
                'only my listings': 'featured-listing',
                'only team listings': 'featured-listing',
                'rental listings': 'featured-listing',
                'single property promotion': 'single-property-promotion'
            };
            let param = Object.assign({}, this.otherSearchParams, {
                listingType: this.listingSource
                    ? listingTypeMap[this.listingSource] || 'featured-listing'
                    : 'all-listing'
            });
            if (param.listingType === 'featured-listing') {
                param.featureListingName = this.listingSource.replace(
                    /^\d\+/,
                    ''
                );
            }
            let ps = (this.centerPointPs = this.axiosIns
                .get('/api-site/search/centerPoint', {
                    params: param
                })
                .then(data => {
                    if (this.centerPointPs === ps && data) {
                        let geoPoint = data.geoPoint;
                        if (flag) {
                            this.mapCenter = {
                                lat: geoPoint.lat,
                                lng: geoPoint.lon
                            };
                        }
                        if (!flag && data.boundary) {
                            data.boundary.noCenter = true;
                        }
                        if (flag || !this.boundary) {
                            this.boundary = data.boundary || null;
                        }
                    }
                }));
        },
        getBoundaries(params) {
            let data = {
            };
            if (
                ['city', 'zip', 'neighborhood'].some(key => {
                    if (params[key]) {
                        data[key] = params[key];
                        return true;
                    }
                })
            ) {
                this.axiosIns
                    .get('/api-hj/hj/getBoundary', {
                        params: data
                    })
                    .then(({ geometry }) => {
                        if (geometry && geometry.length > 0) {
                            this.geometry = geometry;
                        }
                    });
            }
        },
        onSortChange(obj) {
            this.sortUpdateMutation(obj.value);
            util.setStorageItemExpires(localStorageSortKey(), obj.value, 1);
            this.searchDataAction({ 
                listOnly: true,
                isMobile: this.isMobileSize
            });
        },
        switchView(type) {
            if (type === 'map') {
                this.layoutUpdateMutation({
                    layout: this.layout === 'mixed' ? 'normal' : 'mixed',
                    isMobile: this.isMobileSize
                })
                return;
            } else if (this.isMobileSize) {
                type = 'grid';
            }
            this.gridOrListTypeMutation(type);
        },
        collapseList() {
            this.layoutUpdateMutation({
                layout: this.layout === 'map' ? 'mixed' : 'map',
                isMobile: this.isMobileSize
            });
            util.setStorageItemExpires(
                localStorageViewPatternKey(),
                this.mode,
                1
            );
        },
        pageChange(payload) {
            this.pageChangeMutation(payload);
            this.searchDataAction({ 
                listOnly: true,
                isMobile: this.isMobileSize
            });
            this.updateUrl();
        },
        activeMarker(payload) {
            this.activeHouseMarkerMutation(payload);
        },
        resetHeight() {
            const top = this.$el && this.$el.getBoundingClientRect().top;
            this.height =
                Math.floor(
                    Math.max(
                        window.innerHeight - (top || this.top || 0) - 1,
                        600
                    )
                ) + 'px';
        },
        removeAllFilters() {
            this.removeAllFiltersMutation();
            this.$parent &&
                this.$parent.conditionChange({
                    init: false,
                    kee: 'reset',
                    condition: { ...this.searchParamsWithMap }
                });
        },
        removeOutlineRegion() {
            this.removeOutlineRegionMutation();
        },
        initSearchData(query) {
            let zoom = this.zoom;
            // map  Related parameters
            if (query.mapData) {
                let mapData = util.parseJSON(query.mapData);
                if (mapData.centerPoint) {
                    this.centerPoint = mapData.centerPoint;
                }
                if (mapData.property_gathering_amount) {
                    this.property_gathering_amount =
                        mapData.property_gathering_amount;
                }
                if (mapData.zoom) {
                    zoom = this.zoom = mapData.zoom;
                }
            }

            if (query.zoom) {
                if (!isNaN(+query.zoom)) {
                    this.zoom = zoom = +query.zoom;
                }
            }
            this.mapChangeMutation({
                zoom: zoom
            });

            if (query.rect) {
                let points = query.rect.split(',').map(str => +str);
                points.length >= 4 &&
                    (this.centerPoint =
                        (points[0] + points[2]) / 2 +
                        ',' +
                        (points[1] + points[3]) / 2);
            }
            if (query.page) {
                this.pageChangeMutation({
                    page: +query.page || 1
                });
            }
            if (query.quickSearchCount) {
                this.quickSearchStateMutation(1);
            }
        },
        watchKeywords() {
            if (
                !this.mapCondition.mapSearch &&
                !this.mapCondition.mapPath &&
                !this.mapCondition.mapRadius
            ) {
                this.getCenterPoint();
            }
            this.getAverageData();
        },
        getNoneKeywordTypeCenterPoint() {
            if (
                'house' in this.mapResult &&
                Array.isArray(this.mapResult.house) &&
                this.mapResult.house.length
            ) {
                const house = this.mapResult.house;
                const res = {
                    lon: 0,
                    lat: 0,
                    lons: [],
                    lats: []
                };
                let count = 0;
                house.reduce((res, item) => {
                    if (item.longitude && item.latitude) {
                        count++;
                        res.lon += +item.longitude;
                        res.lat += +item.latitude;
                        res.lons.push(+item.longitude);
                        res.lats.push(+item.latitude);
                    }
                    return res;
                }, res);
                this.mapCenter = {
                    lat: res.lat / count,
                    lng: res.lon / count
                };
                this.boundary = null;
            } else {
                //  If the center point is reset ， and no listing data ， Use default center point
                !this.mapCenter.lat &&
                    !this.mapCenter.lng &&
                    this.getDefaultCenterPoint();
            }
        },
        getFormTemplate() {
            let teamId = this.global?.agentCreator?.teamId || '';
            if (!teamId) {
                return;
            }
            this.axiosIns.get(`/api-site/zero-property/${teamId}`).then(res => {
                let data = res?.data;
                if (!data || !data.template) {
                    return;
                }
                let template = JSON.parse(data.template);
                if (!template?.data?.allowShowEmptyListingForm) {
                    return;
                }
                this.allowShowEmptyListingForm = true;
                this.formTemplate = template;
            });
        },
        handlerZoomOut() {
            const minZoom = 4
            if (this.mapData.zoom && this.mapData.zoom > minZoom) {
                this.mapData.zoom = this.mapData.zoom - 1
                this.drawingZoom = this.mapData.zoom;
            }
        }
    },
    afterAsyncData() {
        this.$watch('keywords', this.watchKeywords, {
            deep: true
            // immediate: true
        });
        if (this.keywords.length > 0) {
            setTimeout(() => {
                this.watchKeywords();
            }, 0);
        }
    },
    beforeMount() {
        // this.asyncDataPromise &&
        //     this.asyncDataPromise.then(() => {
        //         this.$watch('keywords', this.watchKeywords, {
        //             deep: true,
        //             immediate: true
        //         });
        //     });
        // this.$nextTick(() => {
        //     this.inBeforeMount = true;
        // })
    },
    mounted() {
        this.inBeforeMount = true;
        if (typeof this.resetParentHeight === 'function') {
            this.$nextTick(() => this.resetParentHeight)
        }
        this.getFormTemplate();
        this.getAverageData();
    }
};
